export default __webpack_public_path__ + "static/media/5.c3330470.jpg";